export default __webpack_public_path__ + "static/img_wave_01-bcb1b40c2182029a74286d82f00a2b8c.png";